import { SearchableSelect } from 'shared';

import { Tool } from 'features/sessions/config/types';
import { useCoachingToolsQuery } from 'features/sessions/hooks';

type CoachingToolsSelectorProps = {
  onSelect: (tool: Tool) => void;
  selected: string;
};

export const SessionsFormCoachingToolsSelector = ({
  onSelect,
  selected,
}: CoachingToolsSelectorProps) => {
  const { data: coachingTools = [], isFetching } = useCoachingToolsQuery();

  return (
    <SearchableSelect
      size="sm"
      items={coachingTools}
      selectedValue={selected}
      onSelect={onSelect}
      isLoading={isFetching}
      placeholder="Select session tool"
      emptyMessage="No tools found"
      loadingMessage="Loading tools..."
      dataTestid="session-tool-selector"
    />
  );
};
